import { DASHBOARD_PATH, DOCUMENT_PATH, INCOME_PATH, INVOICE_PATH, RETENTION_PATH } from './paths'

export const RETENTIONS_RECEIVED_PAGE = INCOME_PATH + DASHBOARD_PATH
export const INVOICES_ISSUED_PAGE = INCOME_PATH + INVOICE_PATH + DASHBOARD_PATH
export const INVOICES_RECEIVED_PAGE = DOCUMENT_PATH + DASHBOARD_PATH
export const RETENTIONS_ISSUED_PAGE = DOCUMENT_PATH + RETENTION_PATH + DASHBOARD_PATH
